export enum EventParticipantType {
    Standard = 1,
    Celebrity = 2,
    Speaker = 3,
    Sponsor = 4,
    Supporter = 5
}
